import React from "react";
import styled from "styled-components";
import Table from "@material-ui/core/Table";

import { breakpoints, color } from "style/constants";

export const StyledTable = styled(({ ...otherProps }) => <Table {...otherProps} />)`
  && {
    max-width: ${breakpoints.xl}px;
    margin: auto;

    thead {
      th {
        border-bottom: none;
      }
    }
    tbody {
      background-color: ${color.WHITE};
      td {
        border-bottom: 3px solid ${color.ADMIN_BACKGROUND};
      }
    }
  }
`;
